// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import fetchTargeting from "../../sagas/getTargeting";

export default function* mainSaga(): Saga<void> {
  yield all([call(fetchTargeting)]);
}
